import { dejavnostService } from '../services/dejavnost.service';
import Vue from 'vue'

const state = {
    dejavnost: [],
    sezona:null,
    predelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,predelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPredelovalecID', predelovalecid)
      return dejavnostService.load(sezona,predelovalecid)
            .then(
                dejavnost => {
                  commit('load', dejavnost);
                  if(makeEditable)
                  commit('makeEditable') 
                  return dejavnost;                   
                } 
                
            );
    },
       loadPreteklaSezona({ dispatch,commit },{sezona,predelovalecid,makeEditable}) {
         dispatch('alert/clear', "",{ root: true });
        //commit('setSezona', sezona)
        //commit('setpredelovalecID', predelovalecid)
        return new Promise((resolve, reject) => {

        
       dejavnostService.loadPreteklaSezona(sezona,predelovalecid)
            .then(
                dejavnost => {
                
                    dejavnost.forEach(e=>{
                        e.id=null;
                        commit("add",e);
                    });

                  if(makeEditable)
                  commit('makeEditable') 
                  resolve(dejavnost);                   
                },
                error =>{
                    console.log(error);
                    dispatch('alert/error', "Nalaganje ni uspelo", { root: true });
                    reject(error);
                }
                
            );
        });
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  dejavnostService.loadAll(sezona)
            .then(
                dejavnost => commit('load', dejavnost)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.dejavnost.sezona;
        let predelovalecid=this.state.dejavnost.predelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.dejavnost.dejavnost.forEach(item=>{
            item.sezona=sezona;
            item.predelovalecid=predelovalecid;
            console.log(item);
            if(!item.proizvodid) {
                 item.saved=false;
                dispatch('alert/error', "Šifrant ni ustrezno izbran", { root: true });

            }
            else if(item.jeaktivna){
              dejavnostService.save(item)
               .then(
                dejavnost => {
                      Vue.set(item,'saved',true);
                     Vue.set(item,'id',dejavnost.id);
                     Vue.set(item,'jeaktivna',1); 
                   // commit("update",item);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             dejavnostService.save(item).then(
                dejavnost => {
                     Vue.set(item,'saved',true);
                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                  //  commit("update",item);
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, dejavnost) {
       if(dejavnost)
        state.dejavnost=dejavnost.map(k=>{
            k["veljavnostcertifikataod"]=kendo.parseDate(k["veljavnostcertifikataod"]) 
            return k;
        }
            );   
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.dejavnost.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.dejavnost.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.dejavnost.length;i++){
            let dateStr=state.dejavnost[i].veljavnostcertifikataod;
            if(dateStr)
                state.dejavnost[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.dejavnost[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.dejavnost[i], { inEdit: true });
            state.dejavnost.splice(i,1,updated);
        }
        

    },
    setPredelovalecID(state, item) {
        state.predelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.dejavnost.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.dejavnost.splice(index,1,updated);
            } else {
                let id = 1;
                state.dejavnost.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.dejavnost.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.dejavnost.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.dejavnost);
                state.dejavnost.splice(index, 1);
        
        //    return data[index];
        //state.dejavnost=data;

    },
    replace(state, dejavnost) {
        state.dejavnost = dejavnost;
    }
   
};

export const dejavnost = {
    namespaced: true,
    state,
    actions,
    mutations
};
